export function Observable<T extends { new (...args: any[]): {} }>(
  constructor: T
) {
  return class extends constructor {
    onChange!: { [key: string]: Array<() => void> };

    constructor(...args: any[]) {
      super(...args);

      if (!this.onChange) {
        this.onChange = {};
      }

      for (const key of Object.keys(this)) {
        if (!this.onChange[key]) {
          this.onChange[key] = [];
        }
        let value = (this as any)[key];
        if (typeof value === "function") continue;

        Object.defineProperty(this, key, {
          get: () => value,
          set: (newValue) => {
            value = newValue;
            if (this.onChange[key]) {
              for (const callback of this.onChange[key]) {
                callback.call(this);
              }
            }
          },
          enumerable: true,
          configurable: true,
        });
      }
    }
  };
}

export function observe<T>(target: T, keys: (keyof T)[], callback: () => void) {
  const t = target as any;
  if (!t.onChange) {
    t.onChange = {};
  }
  for (const key of keys) {
    if (!t.onChange[key]) {
      t.onChange[key] = [];
    }
    t.onChange[key].push(callback);
  }

  return () => {
    for (const key of keys) {
      if (t.onChange && t.onChange[key]) {
        const index = t.onChange[key].indexOf(callback);
        if (index !== -1) {
          t.onChange[key].splice(index, 1);
        }
      }
    }
  };
}
